import type { PropsWithChildren } from 'react';
import AuthService from '../services/auth.service';
import { AuthContext } from './auth.context';

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const authService = new AuthService();
  const value = { ...authService };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
